import { render, staticRenderFns } from "./ModalFeesCollected.vue?vue&type=template&id=1f9662e1&"
import script from "./ModalFeesCollected.vue?vue&type=script&lang=js&"
export * from "./ModalFeesCollected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports